// VORTIK — Popup de captación de email + 15% de descuento.
// El formulario se envía de forma NORMAL (POST + recarga), no por fetch/AJAX:
// el endpoint /contact de Shopify exige un envío de formulario real para su
// protección anti-bot (rechaza peticiones AJAX con "Missing CAPTCHA token").
// En localStorage solo guardamos el ESTADO DE LA INTERFAZ (visto/cerrado/
// suscrito en este navegador), nunca datos del cliente — el email y el
// consentimiento reales viven en Shopify, no aquí.
(function () {
  "use strict";

  var DISMISSED_KEY = "vtk_popup_dismissed_at";
  var SUBSCRIBED_KEY = "vtk_popup_subscribed";
  var REAPPEAR_AFTER_MS = 3 * 24 * 60 * 60 * 1000; // 3 días si solo lo cerró
  var FIRST_SHOW_DELAY_MS = 4000;

  var overlay = document.getElementById("vtk-popup-overlay");
  if (!overlay) return;

  var closeBtn = document.getElementById("vtk-popup-close");
  var reopenBtn = document.getElementById("vtk-popup-reopen");
  var pasoOferta = document.getElementById("vtk-popup-paso-oferta");
  var pasoExito = document.getElementById("vtk-popup-paso-exito");
  var form = document.getElementById("vtk-popup-form");
  var emailInput = document.getElementById("vtk-popup-email");
  var emailField = document.getElementById("vtk-popup-email-field");

  function getFlag(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function setFlag(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function yaSuscrito() { return getFlag(SUBSCRIBED_KEY) === "1"; }

  function puedeReaparecer() {
    var dismissedAt = getFlag(DISMISSED_KEY);
    if (!dismissedAt) return true;
    return Date.now() - parseInt(dismissedAt, 10) > REAPPEAR_AFTER_MS;
  }

  function openPopup() {
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add("vtk-open");
      document.body.style.overflow = "hidden";
      if (emailInput && !pasoOferta.hidden) {
        setTimeout(function () { emailInput.focus(); }, 150);
      }
    });
  }

  function closePopup(recordDismissal) {
    overlay.classList.remove("vtk-open");
    document.body.style.overflow = "";
    if (recordDismissal && !yaSuscrito()) {
      setFlag(DISMISSED_KEY, String(Date.now()));
      showReopenPill();
    }
  }

  function showReopenPill() {
    if (yaSuscrito()) return;
    reopenBtn.hidden = false;
    requestAnimationFrame(function () { reopenBtn.classList.add("vtk-show"); });
  }
  function hideReopenPill() {
    reopenBtn.classList.remove("vtk-show");
  }

  closeBtn.addEventListener("click", function () { closePopup(true); });
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closePopup(true);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("vtk-open")) closePopup(true);
  });
  reopenBtn.addEventListener("click", function () {
    hideReopenPill();
    openPopup();
  });
  var exitoCerrarBtn = document.getElementById("vtk-popup-exito-cerrar");
  if (exitoCerrarBtn) exitoCerrarBtn.addEventListener("click", function () { closePopup(false); });

  // Cualquier elemento con este atributo (p. ej. el CTA de "Mis descuentos")
  // también abre el popup.
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-vtk-popup-reopen]");
    if (!trigger || trigger === reopenBtn) return;
    e.preventDefault();
    hideReopenPill();
    openPopup();
  });

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      var email = (emailInput.value || "").trim();
      if (!validEmail(email)) {
        e.preventDefault();
        emailField.classList.add("vtk-invalid");
        emailInput.focus();
        return;
      }
      emailField.classList.remove("vtk-invalid");
      // A partir de aquí el formulario se envía de forma normal (POST real).
    });
  }

  var yaIniciado = false;
  function iniciar() {
    if (yaIniciado) return;
    yaIniciado = true;

    // Shopify ya procesó el envío en esta misma carga (venimos de un POST
    // real): mostramos el paso de éxito, ya renderizado por el servidor.
    if (window.__vtkPopupJustSubmitted) {
      setFlag(SUBSCRIBED_KEY, "1");
      hideReopenPill();
      openPopup();
      return;
    }

    if (yaSuscrito()) return; // ya tiene su 15%, no molestamos más
    if (!puedeReaparecer()) {
      showReopenPill();
      return;
    }
    setTimeout(function () { openPopup(); }, FIRST_SHOW_DELAY_MS);
  }

  // Respeta el consentimiento de cookies: si Shopify tiene activo su banner
  // nativo de privacidad, esperamos a que el visitante lo resuelva antes de
  // mostrar el popup por primera vez. Si la API no está presente (banner
  // desactivado en el panel), no hay nada que esperar.
  if (window.__vtkPopupJustSubmitted) {
    iniciar();
  } else if (window.Shopify && window.Shopify.customerPrivacy) {
    document.addEventListener("visitorConsentCollected", iniciar, { once: true });
    setTimeout(iniciar, 1200);
  } else {
    iniciar();
  }
})();
